import getObjectKey from 'lib/object/getObjectKey'

interface Options {
  checkIn?: string;
  checkOut?: string;
  occupancies?: Array<App.Occupants> | App.Occupants;
}

function buildPropertyRatesKey(propertyId: string | undefined, options: Options) {
  if (!propertyId) {
    return ''
  }
  return getObjectKey({
    propertyId,
    ...options,
  })
}

export default buildPropertyRatesKey
